import React from 'react';
import { List, ListItem, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    listItem: {
        padding: '8px 16px 8px 16px !important',
        marginBottom: '8px !important',
        border: '1px solid #ebedf8 !important',
        borderRadius: '8px !important',
    },
    listItemHeader: {
        border: '0px !important',
        marginBottom: '8px !important',
        color: '#525050 !important',
        fontWeight: 'bold !important',
    },
}));

const STATUS_COLORS = {
    PENDING: { bg: '#f5f5f5', color: '#757575' },
    PROCESSING: { bg: '#e3f2fd', color: '#1565c0' },
    PROCESSED: { bg: '#e8f5e9', color: '#2e7d32' },
    FAILED: { bg: '#ffebee', color: '#c62828' },
};

const getResponse = (row) => {
    if (row.status === 'PROCESSED')
        return { text: 'Success', color: '#2e7d32' };
    if (row.status === 'PENDING')
        return { text: 'Will be processed soon', color: '#757575' };
    if (row.status === 'PROCESSING')
        return { text: 'In progress', color: '#1565c0' };
    return { text: row.errorMessage ?? '-', color: '#c62828' };
};

const StatusChip = ({ status }) => {
    const style = STATUS_COLORS[status] ?? STATUS_COLORS.PENDING;
    return (
        <Typography
            style={{
                display: 'inline-block',
                fontSize: '13px',
                fontWeight: 600,
                padding: '2px 8px',
                borderRadius: '12px',
                backgroundColor: style.bg,
                color: style.color,
                whiteSpace: 'nowrap',
            }}
        >
            {status ?? '-'}
        </Typography>
    );
};

function ReferralReportItem({ data }) {
    const classes = useStyles();

    return (
        <Box className="hire-item">
            <List component="nav">
                <ListItem className={classes.listItemHeader}>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                        }}
                    >
                        <Box style={{ flex: '0 0 20%' }}>Phone Number</Box>
                        <Box style={{ flex: '0 0 18%' }}>Status</Box>
                        <Box style={{ flex: '0 0 30%' }}>Response</Box>
                        <Box style={{ flex: '0 0 16%' }}>Uploaded At</Box>
                        <Box style={{ flex: '1 1 0' }}>Processed At</Box>
                    </Box>
                </ListItem>

                {data?.map((row, index) => (
                    <ListItem
                        key={row.id ?? index}
                        className={classes.listItem}
                        style={
                            index % 2
                                ? { backgroundColor: 'rgba(241, 243, 246, 1)' }
                                : {}
                        }
                    >
                        <Box
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                alignItems: 'center',
                            }}
                        >
                            <Box style={{ flex: '0 0 20%', paddingRight: 8 }}>
                                <Typography style={{ fontWeight: 600 }}>
                                    {row.referentContactNumber ?? '-'}
                                </Typography>
                            </Box>
                            <Box style={{ flex: '0 0 18%', paddingRight: 8 }}>
                                <StatusChip status={row.status} />
                            </Box>
                            <Box style={{ flex: '0 0 30%', paddingRight: 8 }}>
                                <Typography
                                    style={{
                                        fontSize: '15px',
                                        color: getResponse(row).color,
                                        wordBreak: 'break-word',
                                    }}
                                >
                                    {getResponse(row).text}
                                </Typography>
                            </Box>
                            <Box style={{ flex: '0 0 16%', paddingRight: 8 }}>
                                <Typography style={{ fontSize: '13px' }}>
                                    {row.createdAt
                                        ? moment(row.createdAt).format(
                                              'DD-MMM-YYYY',
                                          )
                                        : '-'}
                                </Typography>
                                <Typography
                                    style={{ fontSize: '13px', color: '#888' }}
                                >
                                    {row.createdAt
                                        ? moment(row.createdAt).format(
                                              'hh:mm A',
                                          )
                                        : ''}
                                </Typography>
                            </Box>
                            <Box style={{ flex: '1 1 0' }}>
                                <Typography style={{ fontSize: '13px' }}>
                                    {row.processedAt
                                        ? moment(row.processedAt).format(
                                              'DD-MMM-YYYY',
                                          )
                                        : '-'}
                                </Typography>
                                <Typography
                                    style={{ fontSize: '13px', color: '#888' }}
                                >
                                    {row.processedAt
                                        ? moment(row.processedAt).format(
                                              'hh:mm A',
                                          )
                                        : ''}
                                </Typography>
                            </Box>
                        </Box>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}

export default ReferralReportItem;
